<template>
<section class="carts-card">
  <div class="carts-card__head"><img :src="imgUrl" :alt="title"></div>
  <div class="carts-card__body carts-card-body">
    <h2 class="carts-card-body__ttl">{{title}}</h2>
    <p class="carts-card-body__author">{{author}}</p>
    <p class="carts-card-body__price">¥ {{price}}<span>(¥ {{priceTax}}税込)</span></p>
    <p class="carts-card-body__point">{{point}}pt ({{pointRate}}%)</p>
    <p class="carts-card-body__ammount">数量:{{ammount}}</p>
    <p class="carts-card-body__store">{{store}}</p>
  </div>
</section>
</template>

<script>
  export default {
    props: {
      imgUrl: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      author: {
        type: String,
        required: true
      },
      price: {
        type: String,
        required: true
      },
      priceTax: {
        type: String,
        required: true
      },
      point: {
        type: String,
        required: true
      },
      pointRate: {
        type: String,
        required: true
      },
      ammount: {
        type: String,
        required: true
      },
      store: {
        type: String,
        required: true
      },
    },
  }
</script>

<style scoped lang="scss">
  .carts-card {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    &__head {
      width: 100px;
      text-align: center;
      @media screen and (max-width: 768px){
        width: 80px;
      }
      img {
        max-width: 60px;
        @media screen and (max-width: 768px){
          max-width: 50px;
        }
      }
    }
    &__body {
      width: calc(100% - 100px);
      @media screen and (max-width: 768px){
        width: calc(100% - 80px);
        padding-right: 5px;
      }
    }
  }

  .carts-card-body {
    text-align: left;
    &__ttl {
      font-size: 14px;
      font-weight: bold;
      @media screen and (max-width: 768px){
        line-height: 1.2;
        padding-top: 2px;
        font-size: 14px;
      }
    }
    &__author {
      font-size: 14px;
      @media screen and (max-width: 768px){
        font-size: 12px;
      }
    }
    &__price {
      color: #FF5B60;
      font-weight: bold;
      font-size: 12px;
      span {
        font-weight: normal;
        margin-left: 5px;
      }
    }
    &__point {
      font-size: 12px;
      color: #FF5B60;
    }
    &__ammount {
      font-size: 12px;
      font-weight: bold;
    }
    &__store {
      font-size: 12px;
      color: #757575;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/carts/parts/ConfirmCard.vue